const TO_BRL = (value) => {
  return value ? parseFloat(value).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : value;
};

export default {
  TO_BRL,
};
